import React, { Fragment, useCallback, useEffect, useReducer, useState } from "react";
import Swal from "sweetalert2";
import {
  getLegajoByData,
  getAllLegajoActivos,
  getAllLegajoConfirmados,
  LegajoHoraExtra,
  UpdateObs
} from "../../api/marcacionApi";
import { getAllUsuario, getUserCredentials } from "../../api/usuarioApi";
import { getAdminById } from "../../api/AdminApi";
import { exportToExcel } from "react-json-to-excel";
import moment from "moment";
import Button from "react-bootstrap/Button";
import ModalHoraExtra from "../components/sis/modalsesiones/Agregarhoraextra";
import ModalObs from "../components/sis/modalsesiones/ModalObs";
import { FaEye, FaExclamationCircle } from "react-icons/fa";
import { IoMdTimer } from "react-icons/io";
import { CiEdit } from "react-icons/ci";
import { TiMinus, TiPlus } from "react-icons/ti";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logoutpath } from "../../store/actions/AuthActions";
import Asistencias from "./sesiones/Asistencias";
import Gastos from "./sesiones/Gastos";
import Spinner from "react-bootstrap/Spinner";
import Logsoperaciones from "./sesiones/logsoperaciones"
import Puntuacion from "./sesiones/Puntuacion"; // arriba del archivo

// Permiso: Solo usuarios con sesiones = "true" pueden ver la página
const columnasExport = [
  "IdLegajoEnfermeria",
  "IdUsuario",
  "Usuario",
  "IdPaciente",
  "Paciente",
  "Fecha",
  "FechaSalida",
  "Modalidad",
  "HoraEntrada",
  "HoraSalida",
  "Latitud",
  "Longitud",
  "Observacion",
  "esFeriado",
  "horascalculadas",
  "horashoraextra",
  "latsalida",
  "longsalida",
  "IdLiquidacion",
  "entradaoriginal",
  "salidaoriginal",
  "isHojaEnfermeria",
  "tieneEvolucion",         // <-- nuevo
  "fechaUltimaEvolucion"    // <-- nuevo
];

const showReducer = (curShow, state) => {
  switch (state.type) {
    case "SHOW":
      return {
        isShow: true,
        typeModal: state.typeModal,
        onReturnValue: state.onReturnValue,
        legajoObject: state.legajoObject,
      };
    case "SHOW2":
      return {
        isShow2: true,
        typeModal: state.typeModal,
        onReturnValue: state.onReturnValue,
        legajoObject: state.legajoObject,
      };
    case "SHOW3":
      return {
        isShow3: true,
        typeModal: state.typeModal,
        onReturnValue: state.onReturnValue,
        legajoObject: state.legajoObject,
      };
    case "END":
      return { ...curShow, isShow: false, isShow2: false, isShow3: false };
    default:
      return curShow;
  }
};


const Sesiones = (props) => {
  const dispatch = useDispatch();
  const [reducer, dispatchReducer] = useReducer(showReducer, {
    isShow: false,
    legajoObject: null,
    onReturnValue: null,
    typeModal: null,
    x: 0,
  });

  // Permisos y loading general
  const [loading, setLoading] = useState(true);
  const [hasPermission, setHasPermission] = useState(undefined);

  // ...Estado y lógica original...
  const [showActivas, setShowActivas] = useState(true);
  const [showAsistencias, setShowAsistencias] = useState(false);
  const [showGastos, setShowGastos] = useState(false);
  const [showUltimas, setShowUltimas] = useState(false);
  const [showLiquidadas, setShowLiquidadas] = useState(false);

  // Loading states for each table
  const [loadingActivas, setLoadingActivas] = useState(false);
  const [loadingUltimas, setLoadingUltimas] = useState(false);
  const [loadingLiquidadas, setLoadingLiquidadas] = useState(false);

  const [List, setList] = useState();
  const [Cliente] = useState("Sesiones");
  const [listMarcacion, setListMarcacion] = useState([]);
  const [alllist, setalllist] = useState([]);
  const [listMarcacion_liquidado, setListMarcacion_liquidado] = useState([]);
  const [alllist_liquidado, setalllist_liquidado] = useState([]);
  const [Legajoactivolist, setLegajoactivo] = useState([]);
  const [FI, setFI] = useState("");
  const [FF, setFF] = useState("");
  const [ItemRow, setItemRow] = useState();
const [showPuntuacion, setShowPuntuacion] = useState(false);

  const [visibleRowsActivas, setVisibleRowsActivas] = useState(10);
  const [visibleRowsUltimas, setVisibleRowsUltimas] = useState(15);
  const [visibleRowsLiquidadas, setVisibleRowsLiquidadas] = useState(15);

  const [pacienteFiltro, setPacienteFiltro] = useState("");
  const [idLiquidacionFiltro, setIdLiquidacionFiltro] = useState("");
  // --------- PERMISOS: chequeo primero ---------
  useEffect(() => {
    const checkPermissionAndLoad = async () => {
      setLoading(true);
      try {
        const resultUser = await getUserCredentials();
        const USERDATA = await getAdminById(resultUser.IdUsuario);
        // Cambia la lógica aquí si tu backend define el permiso de sesiones de otra forma
        if (!USERDATA || USERDATA[0]?.sesiones !== "true") {
          setHasPermission(false);
          setLoading(false);
          return;
        }
        setHasPermission(true);
      } catch (e) {
        setHasPermission(false);
      } finally {
        setLoading(false);
      }
    };
    checkPermissionAndLoad();
    // eslint-disable-next-line
  }, []);

  // --------- Carga de datos solo si tiene permiso ---------
  const loadActivas = useCallback(async () => {
    setLoadingActivas(true);
    try {
      const legajoactivo = await getAllLegajoActivos();
      setLegajoactivo([Legajoactivolist, ...legajoactivo]);
    } catch (err) {
      dispatch(logoutpath(props.history));
      console.log(err);
    } finally {
      setLoadingActivas(false);
    }
    // eslint-disable-next-line
  }, [dispatch, props.history]);

  const handleShowActivas = async () => {
    setShowActivas((prev) => {
      const next = !prev;
      if (next && Legajoactivolist.length <= 1) {
        loadActivas();
      }
      return next;
    });
  };


  const handleShowUltimas = async () => {
    setShowUltimas((prev) => {
      const next = !prev;
      if (next && alllist.length === 0) {
        setLoadingUltimas(true);
        getAllLegajoConfirmados().then((listResult) => {
          const lista_sin_liquidar = listResult.filter(item => item.IdLiquidacion === null);
          setalllist(lista_sin_liquidar);
          setListMarcacion(lista_sin_liquidar);
        }).finally(() => setLoadingUltimas(false));
      }
      return next;
    });
  };

  const handleShowLiquidadas = async () => {
    setShowLiquidadas((prev) => {
      const next = !prev;
      if (next && alllist_liquidado.length === 0) {
        setLoadingLiquidadas(true);
        getAllLegajoConfirmados().then((listResult) => {
          const lista_liquidado = listResult.filter(item => item.IdLiquidacion !== null);
          setalllist_liquidado(lista_liquidado);
          setListMarcacion_liquidado(lista_liquidado);
        }).finally(() => setLoadingLiquidadas(false));
      }
      return next;
    });
  };

  useEffect(() => {
    // Carga automática de Sesiones Activas al montar
    if (hasPermission === true && showActivas && Legajoactivolist.length <= 1) {
      loadActivas();
    }
    // eslint-disable-next-line
  }, [hasPermission]);

  // ...Resto de funciones igual...

  const prepararDatosParaExcel = (data) => {
    return data.map((item) => {
      let filtrado = {};
      columnasExport.forEach((col) => {
        filtrado[col] = item[col] ?? "";
      });
      return filtrado;
    });
  };

  const showModalHoraExtra = (data) => {
    setItemRow(data);
    dispatchReducer({ type: "SHOW2" });
  };
  const exportUltimasToExcel = () => {
    if (listMarcacion.length === 0) {
      Swal.fire("Sin datos", "No hay sesiones para exportar", "info");
      return;
    }
    const datosFiltrados = prepararDatosParaExcel(listMarcacion);
    exportToExcel(datosFiltrados, "Ultimas_Sesiones");
  };

  const exportLiquidadasToExcel = () => {
    if (listMarcacion_liquidado.length === 0) {
      Swal.fire("Sin datos", "No hay sesiones liquidadas para exportar", "info");
      return;
    }
    const datosFiltrados = prepararDatosParaExcel(listMarcacion_liquidado);
    exportToExcel(datosFiltrados, "Sesiones_Liquidadas");
  };


 const buscarmarcacion = async () => {
  if (alllist.length === 0) {
    setLoadingUltimas(true);
    const listResult = await getAllLegajoConfirmados();
    const lista_sin_liquidar = listResult.filter(item => item.IdLiquidacion === null);
    setalllist(lista_sin_liquidar);
    setLoadingUltimas(false);
    setShowUltimas(true);
    // aplicar filtro sobre la lista nueva
    let filtro = lista_sin_liquidar.filter(item => {
      const matchFecha = (!FI || item.Fecha >= FI) && (!FF || item.FechaSalida <= FF);
      const matchPaciente = pacienteFiltro
        ? item.Paciente.toLowerCase().includes(pacienteFiltro.toLowerCase())
        : true;
      return matchFecha && matchPaciente;
    });
    setListMarcacion(filtro);
  } else {
    let filtro = alllist.filter(item => {
      const matchFecha = (!FI || item.Fecha >= FI) && (!FF || item.FechaSalida <= FF);
      const matchPaciente = pacienteFiltro
        ? item.Paciente.toLowerCase().includes(pacienteFiltro.toLowerCase())
        : true;
      return matchFecha && matchPaciente;
    });
    setListMarcacion(filtro);
    setShowUltimas(true);
  }
};

  const buscarmarcacion_liquidado = async () => {
  if (alllist_liquidado.length === 0) {
    setLoadingLiquidadas(true);
    const listResult = await getAllLegajoConfirmados();
    const lista_liquidado = listResult.filter(item => item.IdLiquidacion !== null);
    setalllist_liquidado(lista_liquidado);
    setLoadingLiquidadas(false);
    setShowLiquidadas(true);
    // aplicar filtro sobre la lista nueva
    let filtro = lista_liquidado.filter(item => {
      const matchFecha = (!FI || item.Fecha >= FI) && (!FF || item.FechaSalida <= FF);
      const matchPaciente = pacienteFiltro
        ? item.Paciente.toLowerCase().includes(pacienteFiltro.toLowerCase())
        : true;
      const matchLiquidacion = idLiquidacionFiltro
        ? String(item.IdLiquidacion).includes(idLiquidacionFiltro)
        : true;
      return matchFecha && matchPaciente && matchLiquidacion;
    });
    setListMarcacion_liquidado(filtro);
  } else {
    let filtro = alllist_liquidado.filter(item => {
      const matchFecha = (!FI || item.Fecha >= FI) && (!FF || item.FechaSalida <= FF);
      const matchPaciente = pacienteFiltro
        ? item.Paciente.toLowerCase().includes(pacienteFiltro.toLowerCase())
        : true;
      const matchLiquidacion = idLiquidacionFiltro
        ? String(item.IdLiquidacion).includes(idLiquidacionFiltro)
        : true;
      return matchFecha && matchPaciente && matchLiquidacion;
    });
    setListMarcacion_liquidado(filtro);
    setShowLiquidadas(true);
  }
};

  const showModalObs = (data) => {
    setItemRow(data);
    dispatchReducer({ type: "SHOW3" });
  };

  const onCloseModal = () => {
    dispatchReducer({ type: "END" });
  };


  const CalculateHours = (
    fechaBegin,
    fechaEnd,
    tarifa,
    honorario,
    HoraEntrada,
    HoraSalida
  ) => {
    var fecha1 = moment(fechaBegin + " " + HoraEntrada, "YYYY-MM-DD HH:mm:ss");
    var fecha2 = moment(fechaEnd + " " + HoraSalida, "YYYY-MM-DD HH:mm:ss");
    var diff = fecha2.diff(fecha1, "m");
    return {
      canthoras: Math.round(diff / 60),
      totalHonorario: Math.round((honorario * diff) / 60),
      totalTarifa: Math.round((tarifa * diff) / 60),
    };
  };

 const FuncionHoraExtra = async (data, data2) => {
  dispatchReducer({ type: "END" });
  try {
    if (data.EstaConfirmado == 1) {
      const horascalculadas = CalculateHours(
        data2.Fecha,
        data2.FechaSalida,
        data2.CostoHoraEmpresa,
        data2.CostoHoraProfesional,
        data2.HoraEntrada,
        data2.HoraSalida
      );

      let horaextracalculada = 0, horastrabajadas = 0;
      let horaextra = data.horaextra;
      let cantidadhoraextra = null;
      let IdLegajoEnfermeria = data.IDLEGAJO;
      let horaextramaximo = data.horashoraextra;

      // 👉 Caso especial: si horaextra es "False", omitir requisito mínimo
      if (horaextra === "False") {
        horaextramaximo = null;
        cantidadhoraextra = null;

        const Guardarhoraextra = await LegajoHoraExtra({
          horaextra, cantidadhoraextra, IdLegajoEnfermeria, horaextramaximo
        });

        if (Guardarhoraextra) {
          Swal.fire({
            title: "Hora Extra Cargada",
            html: `Se cargó correctamente`,
            icon: "success",
          });
          if (showActivas) handleShowActivas();
        }
        return; // 👉 corta acá
      }

      // 👉 Caso normal: sí aplica requisito mínimo
      if (horascalculadas.canthoras > data2.TotalHoraMaximo) {
        horastrabajadas = horascalculadas.canthoras - data2.TotalHoraMaximo;

        if (horastrabajadas > data.horashoraextra) {
          horaextracalculada = data.horashoraextra;
        } else {
          horaextracalculada = horastrabajadas;
        }

        cantidadhoraextra = horaextracalculada;

        const Guardarhoraextra = await LegajoHoraExtra({
          horaextra, cantidadhoraextra, IdLegajoEnfermeria, horaextramaximo
        });

        if (Guardarhoraextra) {
          Swal.fire({
            title: "Hora Extra Cargada",
            html: `Se cargó correctamente`,
            icon: "success",
          });
          if (showActivas) handleShowActivas();
        }
      } else {
        Swal.fire({
          title: "Requisitos mínimos para Hora Extra",
          html: `Inválidos`,
          icon: "warning",
        });
      }
    } else {
      // 👉 Caso cuando no está confirmado
      let horaextra = data.horaextra;
      let cantidadhoraextra = null;
      let IdLegajoEnfermeria = data.IDLEGAJO;
      let horaextramaximo = data.horashoraextra;

      if (horaextra === "False") {
        horaextramaximo = null;
        cantidadhoraextra = null;
      }

      const resultConfirm = await LegajoHoraExtra({
        horaextra, cantidadhoraextra, IdLegajoEnfermeria, horaextramaximo
      });

      if (resultConfirm) {
        Swal.fire({
          title: "Hora Extra Cargada",
          html: `Se cargó correctamente`,
          icon: "success",
        });
        if (showActivas) handleShowActivas();
      }
    }
  } catch (err) {
    Swal.close();
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: `${err}`,
    });
  }
};


  const FuncionOBS = async (data) => {
    dispatchReducer({ type: "END" });
    try {
      const GuardarObs = await UpdateObs(data);
      if (GuardarObs) {
        Swal.fire({
          title: "Obs. Cargado",
          html: `Se cargó correctamente`,
          icon: "success",
        });
      } else {
        Swal.fire({
          title: "No se guardó la Obs.",
          html: `Error`,
          icon: "warning",
        });
      }
      if (showActivas) handleShowActivas();
    } catch (err) {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `${err}`,
      });
    }
  };

  // Funciones para manejar "Ver Más" y "Ver Menos"


  const handleViewMoreUltimas = () => {
    setVisibleRowsUltimas(prev => prev + 15);
  };

  const handleViewLessUltimas = () => {
    setVisibleRowsUltimas(15);
  };

  const handleViewMoreLiquidadas = () => {
    setVisibleRowsLiquidadas(prev => prev + 15);
  };

  const handleViewLessLiquidadas = () => {
    setVisibleRowsLiquidadas(15);
  };

  // ------------- Loading y permisos -------------
  if (loading) {
    return (
      <div style={{
        minHeight: "60vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        position: "relative",
        zIndex: 2
      }}>
        <div className="spinner-circle" />
        <span style={{ marginLeft: 14, color: "#444", fontSize: 18 }}>Cargando...</span>



      </div>
    );
  }

  if (hasPermission === false) {
    return (
      <div style={{ textAlign: "center", marginTop: 50 }}>
        <h3>No tiene permisos para ver esta información.</h3>
      </div>
    );
  }
  if (hasPermission !== true) {
    return null;
  }

  // ----------- Render original (sin cambios) -----------

  return (
    <Fragment>

      {/* ...todo el render original igual que antes... */}

      {<div className="col-xl-12 col-lg-12 col-xxl-12 col-sm-12">
        <div className="card">
          <div className="card-header">
            <h4 className="card-title">Sesiones Activas</h4>
            <i variant="secondary" size="sm" onClick={handleShowActivas}>
              {showActivas ? <TiMinus /> : <TiPlus />}
            </i>
          </div>
          {showActivas && (
            <div className="card-body">
              {loadingActivas ? (
                <div className="text-center">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Cargando...</span>
                  </Spinner>
                </div>
              ) : (
                <div className="table-responsive recentOrderTable">
                  <table className="table verticle-middle table-responsive-md">
                    <thead>
                      <tr>
                        <th style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }} scope="col">Cuenta</th>
                        <th style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }} scope="col">Usuario</th>
                        <th style={{
                          maxWidth: '150px',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'wrap',
                        }}>Fecha Entrada</th>
                        <th style={{
                          maxWidth: '150px',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'wrap',
                        }}>Hora Entrada</th>
                        <th style={{
                          maxWidth: '150px',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'wrap',
                        }}>Guardia Hs.</th>
                        <th style={{
                          maxWidth: '150px',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'wrap',
                        }}>Horas Extra</th>
                        <th scope="col">Opciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Legajoactivolist.slice(1).map((item, index2) => (
                        <tr key={index2}>
                          <td>
                            <Link to={`/fichausuario/${item.IdUsuario}`}>
                              {item.Usuario}
                            </Link>
                          </td>
                          <td style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }} scope="col">
                            <Link to={`/Fichaclientes/${item.IdPaciente}`}>
                              {item.Paciente}
                            </Link>
                          </td>
                          <td>{item.Fecha}</td>
                          <td>{item.HoraEntrada}</td>
                          <td>{item.TotalHoraMaximo}</td>
                          <td>{item.horaextramaximo}</td>
                          <td>
                            <Link to={{ pathname: "" }}>
                              <i className="material-icons" onClick={() => showModalObs(item)}>
                                <CiEdit />
                              </i>
                            </Link>
                            <Link to={{ pathname: "" }}>
                              <i className="material-icons" style={{ height: "100" }} onClick={() => showModalHoraExtra(item)}>
                                <IoMdTimer />
                              </i>
                            </Link>
                            <Link to={`/legajo/${item.IdLegajoEnfermeria}`}>
                              <FaEye style={{ fontSize: "18px", marginRight: "6px" }} />
                            </Link>
                            {item.isHojaEnfermeria === "NO" && (
                              <FaExclamationCircle style={{ color: "red", fontSize: "18px" }} />
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

            </div>
          )}
        </div>
      </div>}
      <Logsoperaciones />
      <div className="col-xl-12 col-lg-12 col-xxl-12 col-sm-12">
        <div className="card">
          <div className="card-header">
            <h4 className="card-title">Asistencias</h4>
            <i variant="secondary" size="sm" onClick={() => setShowAsistencias(!showAsistencias)}>
              {showAsistencias ? <TiMinus /> : <TiPlus />}
            </i>
          </div>
          {showAsistencias && (
            <Asistencias></Asistencias>
          )}
        </div>
      </div>
      <div className="col-xl-12 col-lg-12 col-xxl-12 col-sm-12">
        <div className="card">
          <div className="card-header">
            <h4 className="card-title">Gastos</h4>
            <i variant="secondary" size="sm" onClick={() => setShowGastos(!showGastos)}>
              {showGastos ? <TiMinus /> : <TiPlus />}
            </i>
          </div>
          {showGastos && (
            <Gastos metodo="operativa" ></Gastos>
          )}
        </div>
      </div>
      <div className="col-xl-12 col-lg-12 col-xxl-12 col-sm-12">
  <div className="card">
    <div className="card-header">
      <h4 className="card-title">Puntuaciones</h4>
      <i
        variant="secondary"
        size="sm"
        onClick={() => setShowPuntuacion(!showPuntuacion)}
      >
        {showPuntuacion ? <TiMinus /> : <TiPlus />}
      </i>
    </div>
    {showPuntuacion && <Puntuacion />}
  </div>
</div>
      <div className="col-xl-12 col-lg-12 col-xxl-12 col-sm-12">
        <div className="card">
          <div className="card-header">
            <h4 className="card-title m-0">Últimas Sesiones</h4>
            <i variant="secondary" size="sm" onClick={handleShowUltimas}>
              {!showUltimas ? <TiPlus /> : <TiMinus />}
            </i>
          </div>
          <div className="px-4 py-3">
            <div className="row align-items-end gy-2">
              <div className="col-md-3">
                <label className="form-label">Fecha Entrada</label>
                <input type="date" className="form-control" onChange={(e) => setFI(e.target.value)} />
              </div>
              <div className="col-md-3">
                <label className="form-label">Fecha Salida</label>
                <input type="date" className="form-control" onChange={(e) => setFF(e.target.value)} />
              </div>
              <div className="col-md-3">
                <label className="form-label">Paciente</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Buscar paciente..."
                  value={pacienteFiltro}
                  onChange={(e) => setPacienteFiltro(e.target.value)}
                />
              </div>
              <div className="col-md-3 d-flex align-items-end justify-content-end">
                <Button variant="primary" onClick={buscarmarcacion} className="me-2">
                  Filtrar
                </Button>
                <Button variant="success" onClick={exportUltimasToExcel}>
                  Exportar Excel
                </Button>
              </div>
            </div>
          </div>


          {showUltimas && (
            <div className="card-body pt-0">
              {loadingUltimas ? (
                <div className="text-center">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Cargando...</span>
                  </Spinner>
                </div>
              ) : (
                <div className="table-responsive recentOrderTable">
                  <table className="table verticle-middle table-responsive-md">
                    <thead>
                      <tr>
                        <th>Cuenta</th>
                        <th>Usuario</th>
                        <th style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }} scope="col">Fecha Entrada</th>
                        <th style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }} scope="col">Hora Entrada</th>
                        <th style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }} scope="col">Fecha Salida</th>
                        <th style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }} scope="col">Hora Salida</th>
                        <th style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }} scope="col">Total Horas</th>
                        <th style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }} scope="col">Horas Extra</th>
                        <th style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }} scope="col">Honorario total</th>
                        <th>Opciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listMarcacion.slice(0, visibleRowsUltimas).map((item, index) => (
                        <tr key={index}>
                          <td>
                            <Link to={`/fichausuario/${item.IdUsuario}`}>
                              {item.Usuario}
                            </Link>
                          </td>
                          <td style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }} scope="col">
                            <Link to={`/Fichaclientes/${item.IdPaciente}`}>
                              {item.Paciente}
                            </Link>
                          </td>
                          <td>{item.Fecha}</td>
                          <td>{item.HoraEntrada}</td>
                          <td>{item.FechaSalida}</td>
                          <td>{item.HoraSalida}</td>
                          <td>{item.horascalculadas}</td>
                          <td>{item.horashoraextra}</td>
                          <td>
                            {Math.round((item.horascalculadas + item.horashoraextra) * item.CostoHoraProfesional)}
                          </td>
                          <td>
                            <Link to={{ pathname: "" }}>
                              <i className="material-icons" onClick={() => showModalHoraExtra(item)}>
                                <IoMdTimer />
                              </i>
                            </Link>
                            <Link to={{ pathname: "" }}>
                              <i className="material-icons" onClick={() => showModalObs(item)}>
                                <CiEdit />
                              </i>
                            </Link>
                            <Link to={`/legajo/${item.IdLegajoEnfermeria}`}>
                              <i className="material-icons">
                                <FaEye />
                              </i>
                            </Link>
                                <Link>
                            {item.isHojaEnfermeria === "NO" && (
                              <FaExclamationCircle style={{ color: "red", fontSize: "18px" }} />
                            )}
                             </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              <div className="d-flex justify-content-center mt-3">
                {visibleRowsUltimas < listMarcacion.length && (
                  <Button variant="primary" onClick={handleViewMoreUltimas}>
                    Ver Más
                  </Button>
                )}
                {visibleRowsUltimas > 15 && (
                  <Button variant="danger" onClick={handleViewLessUltimas} className="ms-2">
                    Ver Menos
                  </Button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="col-xl-12 col-lg-12 col-xxl-12 col-sm-12">
        <div className="card">
          <div className="card-header">
            <h4 className="card-title">Sesiones Liquidadas</h4>
            <i variant="secondary" size="sm" onClick={handleShowLiquidadas}>
              {!showLiquidadas ? <TiPlus /> : <TiMinus />}
            </i>
          </div>
          <div className="px-4 py-3">
            <div className="row row-cols-lg-auto g-2 align-items-end">
              <div className="col">
                <label className="form-label">Fecha Entrada</label>
                <input type="date" className="form-control" onChange={(e) => setFI(e.target.value)} />
              </div>
              <div className="col">
                <label className="form-label">Fecha Salida</label>
                <input type="date" className="form-control" onChange={(e) => setFF(e.target.value)} />
              </div>
              <div className="col">
                <label className="form-label">Paciente</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Buscar paciente..."
                  value={pacienteFiltro}
                  onChange={(e) => setPacienteFiltro(e.target.value)}
                />
              </div>
              <div className="col">
                <label className="form-label">ID Liquidación</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Buscar por ID..."
                  value={idLiquidacionFiltro}
                  onChange={(e) => setIdLiquidacionFiltro(e.target.value)}
                />
              </div>
              <div className="col text-end">
                <Button variant="primary" onClick={buscarmarcacion_liquidado} className="me-2">
                  Filtrar
                </Button>
                <Button variant="success" onClick={exportLiquidadasToExcel}>
                  Exportar Excel
                </Button>
              </div>
            </div>
          </div>

          {showLiquidadas && (
            <div className="card-body">
              {loadingLiquidadas ? (
                <div className="text-center">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Cargando...</span>
                  </Spinner>
                </div>
              ) : (
                <div className="table-responsive recentOrderTable">
                  <table className="table verticle-middle table-responsive-md">
                    <thead>
                      <tr>
                        <th>Cuenta</th>
                        <th>Usuario</th>
                        <th style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }} scope="col">Fecha Entrada</th>
                        <th style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }} scope="col">Hora Entrada</th>
                        <th style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }} scope="col">Fecha Salida</th>
                        <th style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }} scope="col">Hora Salida</th>
                        <th style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }} scope="col">Total Horas</th>
                        <th style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }} scope="col">Horas Extra</th>
                        <th style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }} scope="col">Honorario total</th>
                        <th>Opciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listMarcacion_liquidado.slice(0, visibleRowsLiquidadas).map((item, index) => (
                        <tr key={index}>
                          <td>
                            <Link to={`/fichausuario/${item.IdUsuario}`}>
                              {item.Usuario}
                            </Link>
                          </td>
                          <td style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }} scope="col">
                            <Link to={`/Fichaclientes/${item.IdPaciente}`}>
                              {item.Paciente}
                            </Link>
                          </td>
                          <td>{item.Fecha}</td>
                          <td>{item.HoraEntrada}</td>
                          <td>{item.FechaSalida}</td>
                          <td>{item.HoraSalida}</td>
                          <td>{item.horascalculadas}</td>
                          <td>{item.horashoraextra}</td>
                          <td>
                            {Math.round((item.horascalculadas + item.horashoraextra) * item.CostoHoraProfesional)}
                          </td>
                          <td>
                            <Link to={`/legajo/${item.IdLegajoEnfermeria}`}>
                              <i className="material-icons" style={{ height: "100" }}>
                                <FaEye />
                              </i>
                            </Link>
                         
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              <div className="d-flex justify-content-center mt-3">
                {visibleRowsLiquidadas < listMarcacion_liquidado.length && (
                  <Button variant="primary" onClick={handleViewMoreLiquidadas}>
                    Ver Más
                  </Button>
                )}
                {visibleRowsLiquidadas > 15 && (
                  <Button variant="danger" onClick={handleViewLessLiquidadas} className="ms-2">
                    Ver Menos
                  </Button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      {reducer.isShow2 && (
        <ModalHoraExtra
          estado={reducer.isShow2}
          onReturnValue={FuncionHoraExtra}
          onCloseModal={onCloseModal}
          item={ItemRow}
        />
      )}
      {reducer.isShow3 && (
        <ModalObs
          estado={reducer.isShow3}
          onReturnValue={FuncionOBS}
          onCloseModal={onCloseModal}
          item={ItemRow}
        />
      )}

    </Fragment>
  );
};

export default Sesiones;